import sendings from './sendings'

const notificationsEvents = {
  hints: {
    balance: {
      limit: {
        balance: 'Уведомим при балансе {amount}',
        onLimit: 'При балансе',
        onNullBalance: 'Уведомим при нулевом балансе',
        noLimit: '<не указан порог>',
        notifyBy: 'уведомлять по',
        noNotifications: '<не уведомлять>',
        overdraft: ' + овердрафт пользователя',
        extraRecipients: 'Уведомления о состоянии баланса всех пользователей системы',
        invoice: 'Приложить счёт на сумму {amount}',
        empty: 'Не указано ни одного лимита баланса.<br>Уведомление о балансе приходить не будут.',
        permission: {
          read: 'У вас нет прав для изменения лимитов.',
          write: 'Вы можете добавить лимит, нажав кнопку "Добавить" ниже.'
        }
      }
    }
  },

  labels: {
    balance: {
      limit: {
        host: 'Хост',
        port: 'Порт',
        from: 'От',
        login: 'Имя пользователя',
        password: 'Пароль',
        limit: 'Порог',

        include: {
          overdraft: 'Учтём овердрафт',
          invoice: {
            detach: 'Открепить счёт на {amount}',
            send: 'Пришлём счёт на {amount}'
          }
        },

        notInclude: {
          overdraft: 'Не учтём овердрафт',
          invoice: 'Не приложим счёт'
        },

        invoice: {
          amount: 'Сумма счёта'
        }
      }
    },

    providers: {
      health: {
        recipients: 'Получатели уведомлений о состоянии провайдеров'
      }
    }
  },

  buttons: {
    balance: {
      limit: {
        invoice: {
          attach: 'Приложить счёт',
          detach: 'Открепить счёт'
        }
      }
    }
  }
}

export const paths = {
  billings: {
    autoAccrual: 'Автопополнение',
    billOnErrors: 'Тарифицировать СМС в случае ошибки',
    currency: 'Валюта',
    overdraft: 'Перерасход',
    processChildrenOperations: 'Обрабатывать финансовые операции дочерних пользователей как свои'
  },

  integrations: {
    pyrus: {
      credentials: 'Данные для подключения к Pyrus'
    }
  },

  referral: {
    billings: {
      processedChildOperations: 'Обрабатывать финансовые операции реферальной программы дочерних пользователей как свои'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Максимальное количество одновременно генерируемых отчётов'
  },

  sendings: {
    allowDuplicates: 'Разрешить дубликаты сообщений',
    sendernamesCheck: 'Ограничить имена отправителей для типов',
    patternsCheck: 'Обязательная проверка по шаблону модерации для типов',

    duplicates: {
      hashFields: 'Поля для проверки на дубли',
      timeout: 'Время блокировки дублей'
    },

    phoneNumber: {
      checkMobile: 'Проверять мобильные номера'
    },

    rateLimit: {
      maxAmount: 'Количество сообщений',
      timeout: 'Временной промежуток'
    },

    tilda: {
      sendFromForms: 'Разрешить отправку сообщений из форм Tilda'
    }
  },

  smpp: {
    defaultMessageType: 'Тип сообщения по умолчанию',
    enabled: 'SMPP включён',
    ipWhitelist: 'Белый список',
    rudeMode: 'Грубый режим'
  },

  webhooks: 'Вебхуки',

  notifications: {
    email: {
      recipients: 'Получатели email уведомлений'
    },

    sms: {
      recipients: 'Получатели SMS уведомлений'
    }
  },

  websocket: {
    channels: 'Каналы'
  }
}
export const descriptions = {
  billings: {
    overdraft: 'Перерасход - это сумма, на которую можно превысить свой баланс. Если перерасход не указан, то он равен нулю.',
    autoAccrual: 'Автопополнение - позволяет автоматически пополнять баланс при достижении порогового значения.',
    processChildrenOperations: 'Если включено, то финансовые операции дочерних пользователей будут обрабатываться как свои.',
    billOnErrors: 'Если включено, то при ошибке отправки СМС будет произведена тарификация.',
    currency: 'Валюта, в которой будут производиться финансовые операции.'
  },

  integrations: {
    pyrus: {
      credentials: 'Имя пользователя и ключ безопасности можно получить в настройках Pyrus.'
    }
  },

  notifications: {
    enabled: 'Включает или отключает все уведомления.',

    email: {
      recipients: 'Укажите email адреса, на которые будут приходить уведомления. Адреса должны быть разделены запятыми или переносами строк.'
    },

    sms: {
      recipients: 'Укажите номера телефонов, на которые будут приходить уведомления. Номера должны быть разделены запятыми или переносами строк. Формат номеров: +79991234567.'
    }
  },

  referral: {
    billings: {
      processedChildOperations: 'Вознаграждение, которое вы получаете за операции дочерних пользователей. Можно задать не более двух строк: одну для начислений и одну для списаний, повторять источник нельзя. Для каждой строки укажите процент от суммы операции и минимальную и максимальную сумму вознаграждения.'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Должно быть больше или равно 0 и меньше 10.'
  },

  sendings: {
    allowDuplicates: 'Разрешает отправку дубликатов сообщений. Если отключено, то дубликаты будут блокироваться.',
    sendernamesCheck: 'Ограничивает имена отправителей для типов. Если включено, то имена отправителей будут проверяться на соответствие шаблонам.',
    patternsCheck: 'Обязательная проверка по шаблону модерации для типов. Если включено, то сообщения будут проверяться на соответствие шаблонамам модерации.',

    duplicates: {
      hashFields: 'Поля, по которым будет проверяться наличие дублей. Если поля не указаны, то будут проверяться все поля сообщения.',
      timeout: 'Время блокировки дублей в секундах. Если время не указано, то дубли будут блокироваться на 24 часа.'
    },

    phoneNumber: {
      checkMobile: 'Проверяет тип номера: допустимы только мобильные. Стационарные и другие немобильные типы считаются некорректными.'
    },

    rateLimit: {
      maxAmount: 'Максимальное количество сообщений, которое можно отправить за указанный временной промежуток.',
      timeout: 'Временной промежуток в секундах, в течение которого будет действовать ограничение на количество сообщений.'
    },

    tilda: {
      sendFromForms: 'Разрешает отправку сообщений из форм Tilda. Если отключено, то сообщения из форм Tilda будут блокироваться.'
    }
  },

  smpp: {
    defaultMessageType: 'Тип сообщения, который будет использоваться по умолчанию для SMPP.',
    enabled: 'Включает или отключает SMPP. Если отключено, то SMPP будет недоступен.',
    ipWhitelist: 'Только валидные IP адреса, разделитель "запятая", "перенос строки".',
    rudeMode: 'Грубый режим SMPP.'
  },

  websocket: {
    channels: 'Каналы, на которые будут отправляться уведомления.'
  }
}

export default {
  title: 'Настройки пользователя',

  titles: {
    sendings: 'Сообщения',
    billings: 'Финансовые операции',
    referral: 'Реферальная программа',
    websocket: 'Websocket',
    smpp: 'SMPP',
    webhooks: 'Webhooks',
    notifications: 'Уведомления',
    integrations: 'Интеграции',
    reports: 'Отчёты'
  },

  subtitles: {
    notifications: {
      events: {
        me: 'Уведомления для себя',
        child: 'Уведомления для дочерних пользователей'
      }
    },

    webhooks: {
      onStatusChange: 'При изменении статуса',
      onIncomingMessage: 'При входящем сообщении',
      request: 'Параметры запроса',
      successOn: 'Условия успешного запроса',
      statuses: 'Статусы'
    }
  },

  dialogs: {
    titles: {
      webhooks: {
        onStatusChange: 'При изменении статуса',
        onIncomingMessage: 'Входящие'
      }
    }
  },

  paths,
  descriptions,

  labels: {
    notSet: 'Не задано',
    notChosen: 'Не выбрано',

    billings: {
      overdraft: 'Перерасход',
      processChildrenOperations: 'Обрабатывать финансовые операции дочерних пользователей как свои',
      billOnErrors: 'Тарифицировать СМС в случае ошибки',
      currency: 'Валюта',

      autoAccrual: {
        limit: 'Порог',
        requiredBalance: 'Необходимый баланс'
      }
    },

    integrations: {
      pyrus: {
        credentials: {
          login: 'Имя пользователя',
          security_key: 'Ключ безопасности'
        }
      },

      yclients: {
        applicationCredentials: {
          id: 'ID приложения',
          token: 'Токен приложения'
        }
      }
    },

    notifications: {
      extraRecipients: 'Получатели уведомлений',
      type: 'Способ уведомления',
      events: notificationsEvents.labels,
      childrenUsersEvents: notificationsEvents.labels
    },

    referral: {
      billings: {
        processedChildOperations: 'Реферальная программа'
      }
    },

    reports: {
      maxConcurrentGenerating: 'Максимальное количество одновременно генерируемых отчётов'
    },

    sendings: {
      allowDuplicates: 'Разрешить дубликаты сообщений',

      rateLimit: {
        maxAmount: 'Количество сообщений',
        timeout: 'Временной промежуток'
      },

      duplicates: {
        hashFields: 'Поля для проверки на дубли',
        timeout: 'Время блокировки дублей'
      },

      tilda: {
        sendFromForms: 'Разрешить отправку сообщений из форм Tilda'
      },

      phoneNumber: {
        checkMobile: 'Проверять мобильные номера'
      }
    },

    smpp: {
      enabled: 'SMPP включён',
      rudeMode: 'Грубый режим SMPP',
      defaultMessageType: 'Тип сообщения по умолчанию для SMPP',
      ipWhitelist: 'Белый список',
      ipAddresses: 'IP адреса',
      confirm: 'Подтверждение сохранения'
    },

    webhooks: {
      url: 'URL',
      method: 'Метод',
      headers: 'Заголовки',
      body: 'Тело',
      maxConnections: 'Соединения',

      successOn: {
        status: 'Статус',
        body: 'Тело'
      },

      extras: {
        statuses: sendings.statuses
      }
    },

    websocket: {
      channels: 'Каналы'
    }
  },

  hints: {
    billings: {
      autoAccrual: {
        limit: 'Порог',
        requiredBalance: 'Необходимый баланс'
      }
    },

    integrations: {
      pyrus: {
        credentials: 'Имя пользователя и ключ безопасности можно получить в настройках Pyrus.'
      }
    },

    notifications: {
      events: notificationsEvents.hints,
      childrenUsersEvents: notificationsEvents.hints
    },

    referral: {
      billings: {
        processedChildOperations: {
          source: 'Источник',
          percent: 'Процент',
          limitMin: 'Минимум',
          limitMax: 'Максимум'
        }
      }
    },

    reports: {
      maxConcurrentGenerating: 'Должно быть больше или равно 0 и меньше 10.'
    },

    sendings: {},

    smpp: {
      ipAddresses: 'Только валидные IP адреса, разделитель "запятая", "перенос строки".'
    },

    webhooks: {
      maxConnections: 'Максимальное количество. По-умолчанию 10.',

      successOn: {
        status: 'Можно использовать регулярные выражения. По-умолчанию 200.',
        body: 'Можно использовать регулярные выражения.'
      }
    },

    websocket: {}
  },

  buttons: {
    notifications: {
      events: notificationsEvents.buttons,
      childrenUsersEvents: notificationsEvents.buttons
    }
  },

  warnings: {
    smpp: {
      ipAddresses: 'Некоторые из указанных IP адресов не прошли проверку на корректность.<br>Если нужно сохранить эти адреса, убедитесь, что они правильные, затем снова введите их в поле "IP адреса" и нажмите "Сохранить".<br>Если адреса по-прежнему окажутся некорректными, это окно не закроется, и список ниже обновится с новыми некорректными адресами.'
    }
  },

  items: {
    websocket: {
      channels: {
        dbUpdates: 'Обновление базы',
        everything: 'Все',
        health: 'Здоровье платформы',
        sendingStatusUpdates: 'Обноление статуса отправлений',
        providersStatesUpdates: 'Обновление состояний провайдеров'
      }
    }
  },

  snackbars: {
    updated: 'Настройка успешно обновлена.'
  }
}
